export default function validateName(value: string): 'EMPTY' | 'INVALID' | null {
  if (value.length === 0) {
    return 'EMPTY';
  }

  if (!/^[a-zA-Z0-9가-힣ㄱ-ㅎㅏ-ㅣ~!#$%^&*+-=?^_{}[\]().' ]+$/.test(value)) {
    return 'INVALID';
  }
  return null;
}
